import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfigIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13639_1022)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.25 9.86816C11.4926 9.86816 12.5 8.8608 12.5 7.61816C12.5 6.37552 11.4926 5.36816 10.25 5.36816C9.00736 5.36816 8 6.37552 8 7.61816C8 8.8608 9.00736 9.86816 10.25 9.86816Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.25 18.8682C17.4926 18.8682 18.5 17.8608 18.5 16.6182C18.5 15.3755 17.4926 14.3682 16.25 14.3682C15.0074 14.3682 14 15.3755 14 16.6182C14 17.8608 15.0074 18.8682 16.25 18.8682Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 7.61816H20.75",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.25 7.61816H8",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5 16.6182H20.75",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.25 16.6182H14",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13639_1022",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.5 0.118164)"
		})
	}) })]
});
export default SvgConfigIcon;
